import { render, staticRenderFns } from "./DetectionEmptyDefaultLayout.vue?vue&type=template&id=00379a90&scoped=true"
import script from "./DetectionEmptyDefaultLayout.vue?vue&type=script&lang=js"
export * from "./DetectionEmptyDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00379a90",
  null
  
)

export default component.exports